// @flow

import React, { PureComponent } from "react";
import styled from "styled-components";

const SVG = styled.svg`
  display: block;
`;

export default class NumberFire extends PureComponent<*> {
  render() {
    return (
      <SVG
        width="73"
        height="16"
        viewBox="0 0 73 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_22033_8654)">
          <path
            d="M15.9139 12.0308V6.25845C15.9139 6.25845 16.2831 6.22768 16.56 6.22768C17.2062 6.22768 17.4954 6.70768 17.4954 7.03384C17.5939 6.86768 18.1723 6.06153 19.1446 6.06153C20.4308 6.06153 21.4339 7.19384 21.4339 8.80614V12.0308H19.7846V9.1323C19.7846 8.15999 19.4646 7.40922 18.4985 7.40922C17.8523 7.40922 17.5939 7.83999 17.5631 7.99999V12.0308H15.9139ZM62.3323 12.0308H60.6831V6.7446C60.6831 6.7446 61.12 6.70768 61.3969 6.70768C62.0369 6.70768 62.3323 7.19384 62.3323 7.51384V12.0308ZM54.5354 7.67999C53.5077 7.51384 52.6523 7.90768 52.4739 8.48614V12.0308H50.8246V6.25845C50.8246 6.25845 51.1323 6.22768 51.4092 6.22768C52.0554 6.22768 52.3446 6.70768 52.3446 7.03384C52.4431 6.86768 52.9231 6.15999 54.2154 6.15999C54.3754 6.15999 54.5046 6.19076 54.5354 6.22768V7.67999ZM66.8 7.67999C65.7662 7.51384 64.9169 7.90768 64.7323 8.48614V12.0308H63.0892V6.25845C63.0892 6.25845 63.3908 6.22768 63.6677 6.22768C64.3139 6.22768 64.6031 6.70768 64.6031 7.03384C64.7015 6.86768 65.1877 6.15999 66.4738 6.15999C66.64 6.15999 66.7692 6.19076 66.8 6.22768V7.67999ZM35.4339 6.06153C34.5477 6.06153 33.8646 6.68307 33.6062 6.94768C33.1939 6.39384 32.5846 6.06153 31.8892 6.06153C30.9169 6.06153 30.3385 6.86768 30.24 7.03384C30.24 6.70768 29.9508 6.22768 29.3046 6.22768C29.0277 6.22768 28.6585 6.25845 28.6585 6.25845V12.0308H30.3077V7.99999C30.3385 7.83999 30.5969 7.40922 31.2431 7.40922C32.2092 7.40922 32.5354 8.15999 32.5354 9.1323V12.0308H34.1785V8.80614C34.1812 8.4471 34.1272 8.08988 34.0185 7.74768C34.1723 7.56922 34.4492 7.40922 34.9539 7.40922C35.92 7.40922 36.2462 8.15999 36.2462 9.1323V12.0308H37.8892V8.80614C37.8892 7.19384 37.0523 6.06153 35.4339 6.06153ZM27.7231 6.22768V12C27.7231 12 27.3539 12.0308 27.0769 12.0308C26.4369 12.0308 26.1415 11.7108 26.1415 11.2246C26.0492 11.3908 25.4339 12.1969 24.4677 12.1969C23.1754 12.1969 22.2092 11.0646 22.2092 9.4523V6.22768H23.8523V9.1323C23.8523 10.0985 24.1415 10.8492 25.1139 10.8492C25.7539 10.8492 26.0492 10.4185 26.08 10.2585V6.22768H27.7231ZM38.6954 3.67384L39.3723 3.64307C40.0185 3.64307 40.3385 3.96922 40.3385 4.44922V6.70768C40.7656 6.30106 41.3303 6.07034 41.92 6.06153C43.2123 6.06153 44.3446 7.2246 44.3446 9.16307C44.3446 10.7754 43.2431 12.1969 41.2739 12.1969C40.1477 12.1969 38.8554 11.84 38.6954 11.7108V3.67384ZM47.6985 6.11691C50.0185 6.11691 50.0862 8.1046 50.0862 8.48614C50.0923 8.84527 50.0488 9.20353 49.9569 9.55076H46.5354C46.5354 10.4185 47.1139 10.9354 48.0862 10.9354C48.4062 10.9354 48.9908 10.8369 48.9908 10.8369C49.44 10.7446 49.9877 11.0646 49.9877 11.7108C49.4092 12.0308 48.7323 12.1969 47.76 12.1969C46.3077 12.1969 44.8554 11.2246 44.8554 9.1323C44.8554 7.35384 45.9877 6.11691 47.6985 6.11691ZM69.7969 6.11691C72.1231 6.11691 72.1846 8.1046 72.1846 8.48614C72.1846 8.96614 72.1231 9.35384 72.0615 9.55076H68.64C68.64 10.4185 69.2185 10.9354 70.1846 10.9354C70.5108 10.9354 71.0892 10.8369 71.0892 10.8369C71.5446 10.7446 72.0923 11.0646 72.0923 11.7108C71.5077 12.0308 70.8308 12.1969 69.8646 12.1969C68.4123 12.1969 66.96 11.2246 66.96 9.1323C66.96 7.35384 68.0923 6.11691 69.7969 6.11691ZM55.28 12.0308V3.96922H59.9569V4.60922C59.9569 5.25537 59.4769 5.6123 58.9908 5.6123H56.9231V7.51384H59.3108V8.96614H56.9231V12.0308H55.28ZM60.5354 4.94153C60.5354 5.13383 60.5924 5.32182 60.6993 5.48171C60.8061 5.64161 60.9579 5.76623 61.1356 5.83982C61.3133 5.91341 61.5088 5.93267 61.6974 5.89515C61.886 5.85764 62.0592 5.76503 62.1952 5.62905C62.3312 5.49307 62.4238 5.31982 62.4613 5.13122C62.4988 4.94261 62.4796 4.74711 62.406 4.56944C62.3324 4.39178 62.2078 4.23992 62.0479 4.13308C61.888 4.02625 61.7 3.96922 61.5077 3.96922H60.5354V4.94153ZM41.4092 7.37845C40.7939 7.37845 40.4062 7.67999 40.3385 7.83999V10.8369C40.5046 10.9354 40.9539 11.0031 41.1139 11.0031C42.0862 11.0031 42.7077 10.4492 42.7077 9.16307C42.7077 8.19076 42.2462 7.37845 41.4092 7.37845ZM47.6308 7.19384C46.9539 7.19384 46.5354 7.83999 46.5354 8.41845H48.5662C48.6339 7.83999 48.2462 7.19384 47.6308 7.19384ZM69.7354 7.19384C69.0585 7.19384 68.64 7.83999 68.64 8.41845H70.6708C70.7385 7.83999 70.3508 7.19384 69.7354 7.19384Z"
            fill="#0A141E"
          />
          <path
            d="M1.87692 13.637C0.984617 12.6339 0.430771 11.3478 0.430771 9.93855C0.430771 7.68009 1.71692 5.42162 3.32923 4.77547C3.65539 5.74162 4.14769 7.04624 6.23385 7.03393C3.97539 2.51701 7.52616 0.258545 8.17231 0.258545C8.17231 2.36316 9.5077 3.80316 10.7323 5.35393L7.28616 11.5262L4.63385 8.69547L1.87692 13.637ZM7.52616 13.4832L4.87385 10.6524L2.75693 14.4493C3.85015 15.2826 5.18543 15.7363 6.56 15.7416C9.78462 15.7416 12.6892 13.1632 12.6892 9.93855C12.6892 8.51701 12.1723 7.39701 11.4892 6.38162L7.52616 13.4832Z"
            fill="url(#paint0_linear_22033_8654)"
          />
          <path
            d="M1.87692 13.637C0.984617 12.6339 0.430771 11.3478 0.430771 9.93855C0.430771 7.68009 1.71692 5.42162 3.32923 4.77547C3.65539 5.74162 4.14769 7.04624 6.23385 7.03393C3.97539 2.51701 7.52616 0.258545 8.17231 0.258545C8.17231 2.36316 9.5077 3.80316 10.7323 5.35393L7.28616 11.5262L4.63385 8.69547L1.87692 13.637ZM7.52616 13.4832L4.87385 10.6524L2.75693 14.4493C3.85015 15.2826 5.18543 15.7363 6.56 15.7416C9.78462 15.7416 12.6892 13.1632 12.6892 9.93855C12.6892 8.51701 12.1723 7.39701 11.4892 6.38162L7.52616 13.4832Z"
            fill="url(#paint1_linear_22033_8654)"
          />
          <path
            d="M4.07385 9.70462L1.88308 13.6369C0.984617 12.6339 0.430771 11.3477 0.430771 9.93847C0.430771 7.68001 1.71692 5.42154 3.32923 4.77539C2.49846 6.16001 2.62769 7.79078 4.07385 9.70462ZM4.87385 10.6523L2.75692 14.4492L2.91077 14.56C5.66154 16.4923 7.47692 13.4339 4.87385 10.6523Z"
            fill="url(#paint2_linear_22033_8654)"
          />
          <path
            d="M11.4892 6.38162C12.1723 7.39701 12.6892 8.51701 12.6892 9.93855C12.6892 13.1632 9.78462 15.7416 6.56 15.7416C5.67707 15.7404 4.80448 15.5516 4 15.1878C6.21539 16.1539 7.26154 15.1816 7.53231 13.477L11.4892 6.38162ZM10.7323 5.35393C9.50769 3.80316 8.17231 2.36316 8.17231 0.258545C7.52616 0.258545 3.97538 2.51701 6.23385 7.03393C6.8731 8.3239 7.30309 9.70734 7.50769 11.1324L10.7323 5.35393Z"
            fill="url(#paint3_linear_22033_8654)"
          />
          <path
            d="M11.4892 6.38162C12.1723 7.397 12.6892 8.517 12.6892 9.93854C12.6892 12.5293 10.8123 14.7016 8.40616 15.4585C10.6215 14.7262 12.1231 11.7724 10.1354 8.80008L11.4892 6.38162ZM9.37231 7.7847L10.7323 5.35393C9.50769 3.80316 8.17231 2.36316 8.17231 0.258545C7.24308 1.48931 6.40616 3.80316 9.37231 7.7847V7.7847Z"
            fill="url(#paint4_linear_22033_8654)"
          />
          <path
            d="M4.07385 9.70462L1.88308 13.6369C0.984617 12.6339 0.430771 11.3477 0.430771 9.93847C0.430771 7.68001 1.71692 5.42154 3.32923 4.77539C2.49846 6.16001 2.62769 7.79078 4.07385 9.70462ZM4.87385 10.6523L2.75692 14.4492L2.91077 14.56C5.66154 16.4923 7.47692 13.4339 4.87385 10.6523Z"
            fill="url(#paint5_linear_22033_8654)"
          />
          <path
            d="M11.4892 6.38162C12.1723 7.39701 12.6892 8.51701 12.6892 9.93855C12.6892 13.1632 9.78462 15.7416 6.56 15.7416C5.67707 15.7404 4.80448 15.5516 4 15.1878C6.21539 16.1539 7.26154 15.1816 7.53231 13.477L11.4892 6.38162ZM10.7323 5.35393C9.50769 3.80316 8.17231 2.36316 8.17231 0.258545C7.52616 0.258545 3.97538 2.51701 6.23385 7.03393C6.8731 8.3239 7.30309 9.70734 7.50769 11.1324L10.7323 5.35393Z"
            fill="url(#paint6_linear_22033_8654)"
          />
          <path
            d="M11.4892 6.38162C12.1723 7.397 12.6892 8.517 12.6892 9.93854C12.6892 12.5293 10.8123 14.7016 8.40616 15.4585C10.6215 14.7262 12.1231 11.7724 10.1354 8.80008L11.4892 6.38162ZM9.37231 7.7847L10.7323 5.35393C9.50769 3.80316 8.17231 2.36316 8.17231 0.258545C7.24308 1.48931 6.40616 3.80316 9.37231 7.7847V7.7847Z"
            fill="url(#paint7_linear_22033_8654)"
          />
          <path
            d="M12.6892 4.43701C12.6892 4.67693 12.5939 4.90703 12.4243 5.07667C12.2546 5.24632 12.0245 5.34163 11.7846 5.34163C11.5447 5.34163 11.3146 5.24632 11.145 5.07667C10.9753 4.90703 10.88 4.67693 10.88 4.43701C10.88 3.79086 11.4646 3.79086 11.1385 2.82471C12.4308 3.14471 12.6892 3.95086 12.6892 4.43701Z"
            fill="url(#paint8_linear_22033_8654)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_22033_8654"
            x1="8.10831"
            y1="7.98655"
            x2="1.98277"
            y2="11.4493"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.18" stopColor="#FFE187" />
            <stop offset="0.24" stopColor="#FFD986" />
            <stop offset="0.33" stopColor="#FFC384" />
            <stop offset="0.44" stopColor="#FFA081" />
            <stop offset="0.55" stopColor="#FF737D" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_22033_8654"
            x1="11.9009"
            y1="8.84685"
            x2="4.97785"
            y2="7.62593"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.24" stopColor="#FFE187" />
            <stop offset="0.28" stopColor="#FFE187" stopOpacity="0.95" />
            <stop offset="0.36" stopColor="#FFE187" stopOpacity="0.83" />
            <stop offset="0.46" stopColor="#FFE187" stopOpacity="0.62" />
            <stop offset="0.58" stopColor="#FFE187" stopOpacity="0.34" />
            <stop offset="0.72" stopColor="#FFE187" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_22033_8654"
            x1="3.28123"
            y1="4.77354"
            x2="3.28123"
            y2="15.1668"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.14" stopColor="#FFE187" />
            <stop offset="0.35" stopColor="#FFC084" />
            <stop offset="0.78" stopColor="#FF737D" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_22033_8654"
            x1="7.28554"
            y1="0.332391"
            x2="8.62031"
            y2="15.5872"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.25" stopColor="#FFE187" />
            <stop offset="0.33" stopColor="#FFD286" />
            <stop offset="0.67" stopColor="#FF8E7F" />
            <stop offset="0.83" stopColor="#FF737D" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_22033_8654"
            x1="12.0123"
            y1="6.79085"
            x2="6.15385"
            y2="8.47024"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.04" stopColor="#FFE187" />
            <stop offset="0.13" stopColor="#FFD686" />
            <stop offset="0.29" stopColor="#FFBA83" />
            <stop offset="0.49" stopColor="#FF8B7F" />
            <stop offset="0.59" stopColor="#FF737D" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_22033_8654"
            x1="5.53108"
            y1="9.28247"
            x2="0.663386"
            y2="11.6566"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFE187" />
            <stop offset="0.03" stopColor="#FFE187" stopOpacity="0.92" />
            <stop offset="0.12" stopColor="#FFE187" stopOpacity="0.71" />
            <stop offset="0.21" stopColor="#FFE187" stopOpacity="0.52" />
            <stop offset="0.31" stopColor="#FFE187" stopOpacity="0.36" />
            <stop offset="0.4" stopColor="#FFE187" stopOpacity="0.23" />
            <stop offset="0.5" stopColor="#FFE187" stopOpacity="0.13" />
            <stop offset="0.6" stopColor="#FFE187" stopOpacity="0.06" />
            <stop offset="0.71" stopColor="#FFE187" stopOpacity="0.01" />
            <stop offset="0.83" stopColor="#FFE187" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_22033_8654"
            x1="12.2898"
            y1="7.17608"
            x2="2.88061"
            y2="8.83516"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.11" stopColor="#FFE187" />
            <stop offset="0.15" stopColor="#FFE187" stopOpacity="0.8" />
            <stop offset="0.19" stopColor="#FFE187" stopOpacity="0.62" />
            <stop offset="0.23" stopColor="#FFE187" stopOpacity="0.45" />
            <stop offset="0.27" stopColor="#FFE187" stopOpacity="0.31" />
            <stop offset="0.32" stopColor="#FFE187" stopOpacity="0.2" />
            <stop offset="0.37" stopColor="#FFE187" stopOpacity="0.11" />
            <stop offset="0.42" stopColor="#FFE187" stopOpacity="0.05" />
            <stop offset="0.48" stopColor="#FFE187" stopOpacity="0.01" />
            <stop offset="0.57" stopColor="#FFE187" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_22033_8654"
            x1="11.4585"
            y1="14.213"
            x2="8.22277"
            y2="6.77177"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.41" stopColor="#FF737D" />
            <stop offset="0.46" stopColor="#FF737D" stopOpacity="0.95" />
            <stop offset="0.54" stopColor="#FF737D" stopOpacity="0.83" />
            <stop offset="0.65" stopColor="#FF737D" stopOpacity="0.62" />
            <stop offset="0.79" stopColor="#FF737D" stopOpacity="0.34" />
            <stop offset="0.93" stopColor="#FF737D" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_22033_8654"
            x1="10.7157"
            y1="3.24748"
            x2="12.9834"
            y2="5.51517"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.11" stopColor="#FFE187" />
            <stop offset="0.35" stopColor="#FFC084" />
            <stop offset="0.84" stopColor="#FF737D" />
          </linearGradient>
          <clipPath id="clip0_22033_8654">
            <rect width="72.6154" height="16" fill="white" />
          </clipPath>
        </defs>
      </SVG>
    );
  }
}
